import React from 'react'
import { formatFriendlyDate } from '../utils/dateUtils'
import { formatRecurrencePattern} from '../utils/recurrenceUtils'

export default function TaskMetadata({ task }) {

  console.log(task)

  const pieces = []

  // Due Date
  if (task.due_date) {
    pieces.push(`📅 ${formatFriendlyDate(task.due_date)}`)
  }

  // Recurrence Pattern
  if (task.is_recurring) {
    const recurrence = formatRecurrencePattern(task)

console.log(
  'RECURRENCE:',
  task.name,
  recurrence,
  task
)

    if (recurrence) {
      pieces.push(`🔄 ${recurrence}`)
    }
  }

  // Project
  if (task.project?.name) {
    pieces.push(`📁 ${task.project.name}`)
  }

  // Context
  if (task.context?.name) {
    pieces.push(`💻 ${task.context.name}`)
  }

  
  // Estimated Time
  if (task.duration?.name) {
    pieces.push(`⏱ ${task.duration.name}`)
  }

  // Priority
  if (task.priority?.name) {
    pieces.push(`⭐ ${task.priority.name}`)
  }

  return (
    <div className="task-metadata">
      {pieces.join(' • ')}
    </div>
  )
}

